<h2 class="toolbarFiltro" >Filtros</h2>
  <mat-divider></mat-divider>
    <div class="check">
      <mat-checkbox color="primary" (change)="adicionaMarcado('promocionais', 'promocionais', $event.checked)"
        [checked]="selecionado('promocionais', 'promocionais')">Promoção
      </mat-checkbox>
    </div>
    @if (this.configService.getConfig().getIdentificarItensNovos !== '') {
    <div class="check">
      <mat-checkbox color="primary" (change)="adicionaMarcado('cadastrosRecentes', 'cadastrosRecentes', $event.checked)"
        [checked]="selecionado('cadastrosRecentes', 'cadastrosRecentes')">Novidade
      </mat-checkbox>
    </div>
    }
  @if (listaMarcas.length > 0) {
  <div>
    <h4>Marca</h4>
    @for (marca of listaMarcas.slice(0, 5); track $index) {
    <div class="check">
      <mat-checkbox color="primary" (change)="adicionaMarcado(marca, 'marca', $event.checked)"
        [checked]="selecionado(marca, 'marca')">{{marca}}
      </mat-checkbox>
    </div>
    }
    @if (listaMarcas.length > 5) {
    <mat-expansion-panel class="painel">
      <mat-expansion-panel-header>
        <mat-panel-title><b>Mais Marcas</b></mat-panel-title>
      </mat-expansion-panel-header>
      @for (marca of listaMarcas.slice(5, listaMarcas.length); track $index) {
      <div class="check">
        <mat-checkbox color="primary" (change)="adicionaMarcado(marca, 'marca', $event.checked)"
          [checked]="selecionado(marca, 'marca')">{{marca}}
        </mat-checkbox>
      </div>
      }
    </mat-expansion-panel>
    }
  </div>
  }
  @if (listaGrupos.length > 1) {
  <div class="divGrupo">
    <h4>Grupo</h4>
    @for (grupo of listaGrupos.slice(0, 5); track $index) {
    <div class="check">
      <mat-checkbox color="primary" (change)="adicionaMarcado(grupo, 'grupo', $event.checked)"
        [checked]="selecionado(grupo, 'grupo')">{{grupo}}
      </mat-checkbox>
    </div>
    }
    @if (listaGrupos.length > 5) {
    <mat-expansion-panel class="painel">
      <mat-expansion-panel-header>
        <mat-panel-title><b>Mais Grupos</b></mat-panel-title>
      </mat-expansion-panel-header>
      @for (grupo of listaGrupos.slice(5, listaGrupos.length); track $index) {
      <div class="check">
        <mat-checkbox color="primary" (change)="adicionaMarcado(grupo, 'grupo', $event.checked)"
          [checked]="selecionado(grupo, 'grupo')">{{grupo}}
        </mat-checkbox>
      </div>
      }
    </mat-expansion-panel>
    }
  </div>
  }
  @if (listaSubGrupos.length > 1) {
  <div class="divSubgrupo">
    <h4>Subgrupo</h4>
    @for (subgrupo of listaSubGrupos.slice(0, 5); track $index) {
    <div class="check">
      <mat-checkbox color="primary" (change)="adicionaMarcado(subgrupo, 'subgrupo', $event.checked)"
        [checked]="selecionado(subgrupo, 'subgrupo')">{{subgrupo}}
      </mat-checkbox>
    </div>
    }
    @if (listaSubGrupos.length > 5) {
    <mat-expansion-panel class="painel">
      <mat-expansion-panel-header>
        <mat-panel-title><b>Mais SubGrupo</b></mat-panel-title>
      </mat-expansion-panel-header>
      @for (subgrupo of listaSubGrupos.slice(5, listaSubGrupos.length); track $index) {
      <div class="check">
        <mat-checkbox color="primary" (change)="adicionaMarcado(subgrupo, 'subgrupo', $event.checked)"
          [checked]="selecionado(subgrupo, 'subgrupo')">{{subgrupo}}
        </mat-checkbox>
      </div>
      }
    </mat-expansion-panel>
    }
  </div>
  }
  @if (listaLinhas.length > 1) {
  <div class="divLinha">
    <h4>Linha</h4>
    @for (linha of listaLinhas.slice(0, 5); track $index) {
    <div class="check">
      <mat-checkbox color="primary" (change)="adicionaMarcado(linha, 'linha', $event.checked)"
        [checked]="selecionado(linha, 'linha')">{{linha}}
      </mat-checkbox>
    </div>
    }
    @if (listaLinhas.length > 5) {
    <mat-expansion-panel class="painel">
      <mat-expansion-panel-header>
        <mat-panel-title><b>Mais Linha</b></mat-panel-title>
      </mat-expansion-panel-header>
      @for (linha of listaLinhas.slice(5, listaLinhas.length); track $index) {
      <div class="check">
        <mat-checkbox color="primary" (change)="adicionaMarcado(linha, 'linha', $event.checked)"
          [checked]="selecionado(linha, 'linha')">{{linha}}
        </mat-checkbox>
      </div>
      }
    </mat-expansion-panel>
    }
  </div>
  }

  <button class="botao-filtrar" mat-raised-button color="primary" (click)="filtraItens()">Filtrar
    <mat-icon style="margin-left: 15px;">filter_list</mat-icon>
  </button>
  <br>
  <button class="botao-filtrar" mat-raised-button color="accent" (click)="limparFiltro()">Limpar Filtro
    <mat-icon style="margin-left: 5px; font-size: 21px;">remove_circle_outline</mat-icon>
  </button>
  <br>
  <br>
